import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GamePromptService {

  constructor() {
  }

  hints = [
    '',
    '',
    'What did the fairy godmother eat?',
    'There were several around the step mother',
    'The Nightingale dropped this',
    'This tasty treat was in the woods',
    'The rat saw himself in this'
  ];

  passwordPrompts = ['',
    '',
    'I may look delicious, but think twice before you take a bite',
    'Cinderella’s carriage was made from one of these',
    'Plume or ruffled i’m used for flight. What am I?',
    'If you say ‘trick or treat’ you might get one of these...',
    'I’d ask this object, \'who’s the fairest of them all?\''
  ];

  answers = ['',
    '',
    'apple',
    'pumpkin',
    'feather',
    'sweet',
    'mirror'
  ];

  letters = [null,
    'E',
    'L',
    'A',
    'O',
    'N'
  ];


  getSectionPasswordPrompt(sectionId): string {
    return this.passwordPrompts[sectionId];
  }

  checkSectionPassword(sectionId, guess): boolean {
    return this.answers[sectionId].toLowerCase() === guess.toLowerCase();
  }

  doesAwardLetter(sectionId): boolean {
    return this.letters[sectionId] != null;
  }

  getLetter(sectionId): string {
    return this.letters[sectionId];
  }

}
